/*
 * Copyright (c) 2020
 *    Reliant Business Valuation, LLC - http://www.reliantvalue.com
 *    Author: Kirill Vizniuk - kirill@internalvaluation.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { ReportSource, SourceValue } from "../../../model/bvq";

@Injectable()
export class ReportSourceService {
  private sources = [
    new ReportSource(null, "Select Source"),
    new ReportSource("BRT", "Broker Report"),
    new ReportSource("BPL", "Business Plan"),
    new ReportSource("BVQ", "Business Valuation Questionnaire"),
    new ReportSource("CTE", "Contact Email"),
    new ReportSource("CMW", "Company Website"),
    new ReportSource("CPC", "Contact Phone Call"),
    new ReportSource("CWU", "Client's Credit Write-Up"),
    new ReportSource("FDD", "Franchise Disclosure Document"),
    new ReportSource("LAG", "Lease Agreement"),
    new ReportSource("LDR", "Lender"),
    new ReportSource("LIF", "Letter of Intent to Finance"),
    new ReportSource("LIP", "Letter of Intent to Purchase"),
    new ReportSource("ORD", "Order Form"),
    new ReportSource("OTH", "Other"),
    new ReportSource("PAT", "Purchase Agreement"),
    new ReportSource("REA", "Real Estate Appraisal"),
    new ReportSource("SHL", "Share Link"),
    new ReportSource("SUP", "Supplemental Questionnaire"),
    new ReportSource("TRS", "Tax Returns"),
    new ReportSource("WEB", "Web"),
  ];

  source = new BehaviorSubject<SourceValue>(
    new SourceValue(this.sources[0].SOURCE_CODE, "")
  );
  source$ = this.source.asObservable();

  /**
   * Set Source by type
   * */
  setSource(type: string, title?: string): void {
    let tempSource = this.source.getValue();
    tempSource.TYPE = type;
    tempSource.SOURCE_TITLE = title;
    this.source.next(tempSource);
  }

  getSources(): ReportSource[] {
    return this.sources;
  }

  getSource(src: string, fieldNote: string = ""): string {
    if (src) {
      switch (src) {
        case "CWU":
          return "Client's Credit Write-Up";
        case "TRS":
          return "Tax Returns";
        case "CPC":
          return "Contact Phone Call";
        case "CMW":
          return "Company Website";
        case "CTE":
          return "Contact Email";
        case "BRT":
          return "Broker Report";
        case "PAT":
          return "Purchase Agreement";
        case "LDR":
          return "Lender";
        case "FDD":
          return "Franchise Disclosure Document";
        case "OTH":
          if (fieldNote) return fieldNote;
          else return "Other";
        case "WEB":
          return "Web";
        case "SHL":
          return "Share Link";
        case "ORD":
          return "Order Form";
        case "BVQ":
          return "BVQ";
        case "LAG":
          return "Lease Agreement";
        case "BPL":
          return "Business Plan";
        case "LIP":
          return "Letter / Purchase";
        case "LIF":
          return "Letter / Finance";
        case "SUP":
          return "Supplemental Questionnaire";
        case "REA":
          return "Real Estate";
        default:
          return "";
      }
    } else return "";
  }

  isOther(src: string): boolean {
    return src === "OTH";
  }

  get isDisable(): boolean {
    if (
      this.source.getValue().TYPE == null ||
      this.source.getValue().TYPE == "null"
    )
      return true;

    return false;
  }
}
